var _rect, _path, _path2, _line, _line2, _line3, _line4, _line5, _line6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTerminals(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 83,
    width: 100,
    height: 7,
    fill: "#F7931E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.75 82.25V16.1917C15.4571 13.5444 23.3877 12.5885 31.1033 12.7719C38.8113 12.955 46.3338 14.2751 56.25 16.2224V82.25H4.75Z",
    fill: "#29ABE2",
    stroke: "#F7931E",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.75 82.25V25.8429C66.7132 23.4228 72.81 22.5915 78.0548 22.7743C83.0793 22.9495 87.355 24.054 93.5803 25.6622C93.801 25.7192 94.0242 25.7768 94.25 25.8351V82.25H56.75Z",
    fill: "#29ABE2",
    stroke: "#F7931E",
    strokeWidth: 1.5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 13.5,
    y1: 15,
    x2: 13.5,
    y2: 49,
    stroke: "#F7931E"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 21.5,
    y1: 14,
    x2: 21.5,
    y2: 49,
    stroke: "#F7931E"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 19.5,
    x2: 21,
    y2: 19.5,
    stroke: "#F7931E"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 26.5,
    x2: 21,
    y2: 26.5,
    stroke: "#F7931E"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 34.5,
    x2: 21,
    y2: 34.5,
    stroke: "#F7931E"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 41.5,
    x2: 21,
    y2: 41.5,
    stroke: "#F7931E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerminals);
export default __webpack_public_path__ + "static/media/Terminals.4dc05535357c504fe5e568fde4d27a46.svg";
export { ForwardRef as ReactComponent };